import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { InfoCircle } from "react-bootstrap-icons";
import { useAuth } from "react-oidc-context";
import { authUtils } from "../common/authUtils";
import { UserModel } from "../api/userAPI";

interface CheckoutProps {
  checkedOutBy: UserModel | undefined;
  unsavedChangesDrawing: boolean;
  unsavedChangesModelInfo: boolean;
  unsavedChangesComponents: boolean;
  onCheckin: (force: boolean) => void;
  onCheckout: () => void;
}

function Checkout({
  checkedOutBy,
  unsavedChangesDrawing,
  unsavedChangesModelInfo,
  unsavedChangesComponents,
  onCheckin,
  onCheckout,
}: CheckoutProps) {
  const auth = useAuth();

  const loadToolTipMessage = (): string => {
    if (
      unsavedChangesModelInfo ||
      unsavedChangesComponents ||
      unsavedChangesDrawing
    ) {
      var tabs = [];
      var baseMessage = "You have unsaved changes";

      if (unsavedChangesModelInfo) {
        tabs.push("'Model Info'");
      }
      if (unsavedChangesDrawing) {
        tabs.push("'Drawing'");
      }
      if (unsavedChangesComponents) {
        tabs.push("'Components'");
      }

      return baseMessage + " in the following tab(s): " + tabs.join(", ") + ".";
    } else {
      return "Check in the vehicle file.";
    }
  };

  if (checkedOutBy?.email === auth.user?.profile.email)
    return (
      <>
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id="tooltip-disabled">{loadToolTipMessage()}</Tooltip>
          }
        >
          <div>
            <Button
              variant="info"
              size="sm"
              disabled={
                unsavedChangesDrawing ||
                unsavedChangesModelInfo ||
                unsavedChangesComponents
              }
              onClick={() => onCheckin(false)}
            >
              Check in
            </Button>
            <InfoCircle
              className="ms-2"
              visibility={
                unsavedChangesDrawing ||
                unsavedChangesModelInfo ||
                unsavedChangesComponents
                  ? "visible"
                  : "hidden"
              }
              style={{ cursor: "help" }}
              color="rgb(255,128,128)"
              size="16"
            />
          </div>
        </OverlayTrigger>
      </>
    );

  if (checkedOutBy) {
    if (authUtils.isAdministrator(auth)) {
      return (
        <Button variant="warning" size="sm" onClick={() => onCheckin(true)}>
          Force checkin for {checkedOutBy.name}
        </Button>
      );
    } else {
      return <span>File is checked out by {checkedOutBy.name}</span>;
    }
  }

  return (
    <>
      <Button
        variant="success"
        size="sm"
        className="btn"
        onClick={() => onCheckout()}
      >
        Checkout
      </Button>
    </>
  );
}

export default Checkout;
